import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import UserHeader from "./UserHeader";
import UserSubHeader from "./UserSubHeader";
import noDataImg from "../../assets/img/banner/no-data.png";

import { getpassiveEarning } from "../../redux/actions/earning";

const PassiveIncome = () => {
  const dispatch = useDispatch();

  const passiveIncomeData = useSelector(
    (state) => state.earning.passiveIncomeData?.data
  );

  const loading = useSelector((state) => state.earning.loading);

  useEffect(() => {
    dispatch(getpassiveEarning());
  }, [dispatch]);

  console.log("Passive Income Data : ", passiveIncomeData);

  return (
    <div>
      <UserHeader />
      <UserSubHeader pageTitle={"Revenue"} subTitle={"Daily Growth Income"} />

      <section className="package-pricing-wrapper fix section-bg-4 section-padding">
        <div className="container">
          <div className="card">
            <div className="row row-bordered g-0">
              <div className="col-lg-12 p-2">
                <div className="card-header bg-dark">
                  <div className="card-title text-center mb-0">
                    <h5 className="m-0 me-2">Daily Growth Report</h5>
                  </div>
                </div>

                <div className="card-body text-center">
                  <div className="table-responsive">
                    {loading ? (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading daily growth data...</p>
                      </div>
                    ) : passiveIncomeData && passiveIncomeData.length > 0 ? (
                      <table className="table table-bordered table-dark table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Package Name</th>
                            <th>Pkg Amount</th>
                            <th>Growth Amount</th>
                            <th>Growth for Date</th>
                            <th>Growth Day</th>
                          </tr>
                        </thead>
                        <tbody>
                          {passiveIncomeData.map((passIncome, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>{passIncome?.packageName || 'N/A'}</td>
                              <td>${passIncome?.amount || '0.00'}</td>
                              <td>${passIncome?.growthAmount || '0.00'}</td>
                              <td>{passIncome?.date || 'N/A'}</td>
                              <td>{passIncome?.daysSinceCreation || '0'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="no-data text-center rounded rounded-bottom">
                        <img src={noDataImg} alt="No Data" className="img-fluid" />
                        <p className="mt-2">No daily growth data available</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PassiveIncome;